module.exports = __webpack_public_path__ + "static/media/_5205922-1-2.898acc33.jpg";